export default __webpack_public_path__ + "static/media/4-1.c372606b.mp3";